"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePLSQueryParams = void 0;

var _utils = require("@navinc/utils");

var _isPlsUrl = require("./is-pls-url");

var updatePLSQueryParams = function updatePLSQueryParams(applyUrlString, params) {
  var url;

  try {
    url = new URL(applyUrlString);
  } catch (_unused) {
    return applyUrlString;
  }

  if ((0, _isPlsUrl.isPlsUrl)(url)) {
    return (0, _utils.addUrlParamsWithoutOverwriting)(url, params).toString();
  } // Don't do anything for non-PLS urls


  return applyUrlString;
};

exports.updatePLSQueryParams = updatePLSQueryParams;
//# sourceMappingURL=update-pls-query-params.js.map